import { gql } from '@apollo/client';

export const GET_PROFILE = gql`
	query {
		getProfile {
			id
			email
			companyDetails {
				jobType
				name
				userType
				website
			}
			favoriteProducts {
				pid
				addDate
			}
			ingredientsTemplateId
			isBrandAdmin
		}
	}
`;
